export type FullNameLike =
  | {
      fullName?: string | null;
      forename?: string | null;
      surname?: string | null;
    }
  | null
  | undefined;

export const formatFullName = (input: FullNameLike): string => {
  if (!input) return '';

  const fullName = input.fullName?.trim();
  if (fullName) return fullName;

  const forename = input.forename?.trim() || '';
  const surname = input.surname?.trim() || '';

  return `${forename} ${surname}`.trim();
};

